import { Injectable } from "@angular/core";
import { StkmfServicePkg } from "./stkmfPkg.service";
import { AgTextAreaEditor } from "jk-service";
@Injectable({
  providedIn: "root",
})
export class StkmfService extends StkmfServicePkg {
  constructor() {
    super();
  }
  override async init() {
    super.init();
    this.columnDefsVir = [
      {
        field: "MF002C",
        headerName: "名稱",
        headerTooltip: "",
        width: 230,
        cellDataType: "text",
      },
      {
        field: "STKMA006",
        headerName: "摘要",
        headerTooltip: "",
        width: 250,
        cellDataType: "text",
      },
      {
        field: "STKMA028",
        headerName: "XQ股票代號",
        headerTooltip: "",
        width: 198,
        cellDataType: "text",
      },
      {
        field: "STKMA047",
        headerName: "群組",
        headerTooltip: "",
        width: 250,
        cellDataType: "text",
        cellRenderer: AgTextAreaEditor,
      },
      {
        field: "DATEX",
        headerName: "市價日期",
        headerTooltip: "",
        width: 120,
        cellDataType: "text",
      },
      {
        field: "LG005",
        headerName: "成交張數",
        headerTooltip: "",
        width: 158,
        cellDataType: "number",
        cellStyle: { "text-align": "right" },
      },
      {
        field: "LG006",
        headerName: "成交量",
        headerTooltip: "",
        width: 158,
        cellDataType: "number",
        cellStyle: { "text-align": "right" },
      },
      {
        field: "LG007",
        headerName: "開盤價",
        headerTooltip: "",
        width: 160,
        cellDataType: "number",
        cellStyle: { "text-align": "right" },
      },
      {
        field: "LG008",
        headerName: "最高價",
        headerTooltip: "",
        width: 160,
        cellDataType: "number",
        cellStyle: { "text-align": "right" },
      },
      {
        field: "LG009",
        headerName: "最低價",
        headerTooltip: "",
        width: 160,
        cellDataType: "number",
        cellStyle: { "text-align": "right" },
      },
      {
        field: "LG010",
        headerName: "收盤價",
        headerTooltip: "",
        width: 160,
        cellDataType: "number",
        cellStyle: { "text-align": "right" },
      },
      {
        field: "LG024",
        headerName: "漲跌",
        headerTooltip: "",
        width: 160,
        cellDataType: "number",
        cellStyle: { "text-align": "right" },
      },
      {
        field: "LG025",
        headerName: "SMA5",
        headerTooltip: "",
        width: 160,
        cellDataType: "number",
        cellStyle: { "text-align": "right" },
      },
    ];
  }
  async doAddGroup(groupno: string, stockno: string): Promise<boolean> {
    await this.doInsert();
    this.item.MF001 = groupno;
    this.item.MF002 = stockno;
    this.item.MF003 = 99;
    this.item.MF004 = "N";
    this.item.MF006 = this.nowDate();
    return await this.doMyOk();
  }
  async getGroupStocks(groupno: string, isAll: boolean): Promise<string[]> {
    let r: string[] = [];
    if (!groupno) return r;
    let sql =
      `SELECT MF002 FROM STKMF WHERE MF001='${groupno}' ` +
      this.iif(isAll, "", ` AND MF004='Y'`) +
      " ORDER BY MF002 ";
    let rows = await this.orm.simpleSqlPromise(this.host, sql, this.ret);
    if (rows.length > 0) {
      for (let i = 0; i < rows.length; i++) {
        r.push(rows[i].MF002);
      }
    }
    return r;
  }
}
